module.exports = {"uah":{"title":"грн","translit":"uah","slug":"uah","id":1917},"usd":{"title":"$","translit":"usd","slug":"usd","currency":"usd","id":1915},"eur":{"title":"€","translit":"eur","slug":"eur","currency":"eur","id":1916}}


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/currencyObj.json
// module id = 2722
// module chunks = 17 28